/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Suffix_LabelInputs */



/**
* | output |
* | --- |
* | "Output filename suffix" |
*
* @param {Audio_Embed_Export_Suffix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_suffix_label = /** @type {((inputs?: Audio_Embed_Export_Suffix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Suffix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("suffixe du nom de fichier de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateinamenserweiterung für die Ausgabedatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("suffisso del nome del file di output")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Суффикс имени выходного файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("sufijo del nombre del archivo de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出文件名后缀")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力ファイル名の接尾辞")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट फ़ाइलनाम प्रत्यय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("sufixo do nome do arquivo de saída")
	return /** @type {LocalizedString} */ ("Output filename suffix")
});